import { render, staticRenderFns } from "./info-text.vue?vue&type=template&id=5ff56b1c"
import script from "./info-text.vue?vue&type=script&lang=js"
export * from "./info-text.vue?vue&type=script&lang=js"
import style0 from "./info-text.vue?vue&type=style&index=0&id=5ff56b1c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports